<template>
        <div class="blog-detail-wrapper" >
          <b-row>
            <!-- blogs -->
            <b-col cols="12">
              <b-card>
                <b-media no-body>
                  <b-media-aside
                    vertical-align="center"
                    class="mr-50"
                  >
                    <b-avatar
                      href="javascript:void(0)"
                      size="24"
                      :src="item.user.profile_image_path"
                    />
                  </b-media-aside>
                  <b-media-body>
                    <small class="text-muted mr-50">by</small>
                    <small>
                      <b-link class="text-body">{{item.user.full_name}}</b-link>
                    </small>
                    <span class="text-muted ml-75 mr-50">|</span>
                    <small class="text-muted">{{item.created_at}}</small>
                  </b-media-body>
                </b-media>


                <!-- user forum answers -->
                <b-media
                  no-body
                >
                  <b-media-aside>
                    <b-avatar
                      size="60"
                      :src="item.user.profile_image_path"
                    />
                  </b-media-aside>
                  <b-media-body>
                    <h6 class="font-weight-bolder">
                     {{item.name}}
                    </h6>
                    <b-card-text>
                      {{item.questions[0].question}}
                    </b-card-text>
                  </b-media-body>
                </b-media>

              </b-card>
            </b-col>
            <!--/ blogs -->

            <!-- blog answers -->
            <b-col
              id="blogComment"
              cols="12"
              class="mt-2"
              v-if=" load == false "
            >
              <h6 class="section-label">
                {{$t('activities.students_opinions_about_forum')}}
              </h6>
              <b-card
                v-for="(answer,index) in forum_answers"
                :key="index"
              >
                <b-media no-body>
                  <b-media-aside class="mr-75" 
                  v-if="answer.grade && (user.id==answer.user.id ||user.account_type==='teacher')"
                  v-b-tooltip.hover.right="$t('activities.grade')">
                      <b-badge>{{(answer.grade*(item.grade/100)).toFixed(2)}}/{{item.grade}}</b-badge>
                  </b-media-aside>
                  <b-media-aside class="mr-75">
                    <b-avatar
                      :src="answer.user.profile_image_path"
                      size="38"
                    />
                  </b-media-aside>
                  <b-media-body>
                    <h6 class="font-weight-bolder mb-25">
                      {{answer.user.full_name}}
                    </h6>
                    <b-card-text>{{answer.created_at}}</b-card-text>
                    <b-card-text
                    v-html="answer.answer"
                    v-if="answer.answer"
                    >
                      <!-- {{answer.answer}} -->
                    </b-card-text>
                    <b-card-text v-else>
                      {{user.id==answer.user.id? $t('activities.you_uploaded_file'):$t('activities.student_uploaded_file')}}
                      <b-button
                        variant="outline-success"
                        :href="answer.file"
                        target= '_blank'
                      >
                        <i class="fa fa-download"></i>
                        {{ $t("activities.press_to_download") }}
                      </b-button>
                    </b-card-text>
                    <b-link v-if="user.id==answer.user.id && answer.grade===null && answer.file===null && checkTime(item)" @click="editAnswer(answer)">
                      <div class="d-inline-flex align-items-center"  v-if="user.account_type==='student'">
                        <feather-icon
                          icon="CornerDownLeftIcon"
                          size="18"
                          class="mr-50"
                        />
                        <span>{{$t('site.edit')}}</span>
                      </div>
                  </b-link>
                  </b-media-body>
                </b-media>
              </b-card>
            </b-col>
            <b-spinner v-else type="grow" label="Loading..."  class="loading" />
            <!--/ blog comment -->

            <!-- Leave a Blog Comment -->
            <b-col
              cols="12"
              class="mt-2"
              v-if="(totalAnswers<3 && checkTime(item)) || (edit && checkTime(item)) ||user.account_type==='teacher'"
            >
              <h6 class="section-label">
                {{$t('activities.upload_your_forum')}}
              </h6>
              <b-card>
                 <validation-observer ref="registerForm" #default="{ invalid }">
                <b-form>
                  <b-row>
                    <b-col cols="12">
                      <validation-provider
                        #default="{ errors }"
                        :name="$t('activities.answer')"
                        vid="forum_answer"
                        rules="required"
                      >
                        <b-form-group class="mb-2">
                          <ckeditor
                            :config="{ contentsLangDirection : 'rtl',versionCheck : false}" 
                            v-model="newAnswer.answer"
                            :placeholder="$t('activities.answer')"
                            v-if="text_or_file==1"
                            :state="errors.length > 0 ? false : null"
                          />
                          <b-form-file
                            v-else
                            v-model="newAnswer.file"
                            placeholder="اختيار ملف أو تسقطها هنا ..."
                            drop-placeholder="إسقاط الملف هنا ..."
                            accept="application/pdf,.ppt,.pptx,docx"
                            :state="errors.length > 0 ? false : null"
                          />
                        </b-form-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>   
                    </b-col>
                    <b-col cols="12">
                      <b-form-checkbox
                        id="checkbox-1"
                        v-model="text_or_file"
                        name="checkbox-1"
                        value="2"
                        unchecked-value="1"
                        v-if="user.account_type==='student'"
                      >
                        {{$t('activities.file_upload')}}
                      </b-form-checkbox>
                    </b-col>
                    <b-col cols="12">
                      <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        :disabled="invalid"
                        variant="primary"
                         @click="submit()"
                      >
                        {{$t('site.add')}}
                      </b-button>
                    </b-col>
                  </b-row>
                </b-form>
                </validation-observer>
              </b-card>
            </b-col>
            <!--/ Leave a Blog Comment -->
          </b-row>
          <!--/ blogs -->
        </div>
</template>

<script>
import Ripple from 'vue-ripple-directive';
import ActivitiesController from '@/Controllers/ActivitiesController';
import Auth from "@/Apis/Auth";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
export default {
  props: ["item"],
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
    },
  data() {
    return {
      file: {},
      edit:false,
      forum_answers:[],
      newAnswer:{},
      text_or_file:1,
      user:{},
      load: false,
      myTotalAnswersFlag:true,
      totalAnswers:0
    }
  },
  directives: {
    Ripple,
    },
  async created(){
    this.load=true;
    this.user = Auth.USER;
    if(this.$props.item.type==='forum'){
        await this.getAnswers();
        console.log(this.forum_answers);
    }
    this.load=false;
  },
  methods:{
    checkTime(item) {
      const check = new Date();
      console.log(item.start_date);

      const stDate = new Date(item.start_date);
      const enDate = new Date(item.end_date);
      console.log(stDate,enDate)
      if (
        check.getTime() <= enDate.getTime() &&
        check.getTime() >= stDate.getTime()
      )
        return true;
      // && datanow <= enDate) return true;
      return false;
    },
    async getAnswers(){
        this.load=true;
        const data = await new ActivitiesController().forum_answers({'question_id':this.$props.item.questions[0].id});
        this.forum_answers=data;
        this.countMyTotalAnswers();
        this.load=false;
    },
    countMyTotalAnswers(){
      let flag=0;
      this.forum_answers.forEach((el)=>{
        if(el.grade==null &&el.file==null)flag=1;
      });
      this.totalAnswers = this.forum_answers.filter(obj => {
        if (obj.user_id ==this.user.id) {
          return true;
        }
        return false;
      }).length;

      this.myTotalAnswersFlag=(this.totalAnswers < 3 || flag)?true:false;
      console.log(this.myTotalAnswersFlag);
    },
    editAnswer(answer){
      this.edit=true;
      window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
      this.newAnswer=answer;
      console.log(this.newAnswer);

    },
    async submit(){
      this.dataHandle();
      console.log(this.newAnswer);
      console.log("manaa");
      let ret = await new ActivitiesController().activity_answer(this.newAnswer);
      if(ret){
        this.load=true;
        await this.getAnswers();
        window.scrollTo(0,0);
        this.newAnswer={};
        this.edit=false;
        this.text_or_file=1;
        this.load=false;
      }
      console.log("hla",ret);
    },
    dataHandle(){
      this.newAnswer.answer_number=this.totalAnswers+1;
      this.newAnswer.activity_question_id=this.$props.item.questions[0].id;
      this.newAnswer.user_id=this.user.id;
      this.newAnswer.user=this.user;
      this.newAnswer.activity=this.$props.item;
      if(this.text_or_file==1){
        this.newAnswer.file=null;
      }else{
        this.newAnswer.answer=null;
      }
    }

  },
  watch:{
    text_or_file(){
      console.log("hi",this.text_or_file)
    }
  }
}
</script>
<style>

</style>